// extracted by mini-css-extract-plugin
export var dividerContainer = "_8t-0";
export var line = "_8t-1";